import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import {ff, utils, Loader, form} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
const {Form, FormActions, FormBody} = form;
import * as subjektActions from "../actions/subjektActions";
import CustomCheckboxField from "../components/CustomCheckboxField";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Formulář pro tvorbu/úpravu karty.
 */
class KartaForm extends Component<WithTranslation> {

    static formName = 'KartaForm';

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        const {initialValues} = this.props;
        if (initialValues && initialValues.spolecnost) {
            this.props.dispatch(subjektActions.fetchUzivateleSpolecnostIfNeeded(initialValues.spolecnost.id));
        }
    };

    render() {
        const {onClose, submitting, handleSubmit, uzivateleSpolecnostList, t} = this.props;
        return uzivateleSpolecnostList ? <Form onSubmit={handleSubmit} horizontal>
            <FormBody>
                <ff.String label={t('card_number')} name="cisloKarta" disabled={submitting}/>
                <ff.String label={t('chip_number')} name="cisloChip" disabled={submitting}/>
                <ff.SimpleDate label={t('issue_date')} name="datumVydano" disabled={submitting}/>
                <ff.SimpleDate label={t('expiry_date')} name="datumPlatnost" disabled={submitting}/>
                <ff.ObjectSuggest
                    label={t('employee.single')}
                    name="uzivatel"
                    items={uzivateleSpolecnostList.rows}
                    dropdown={true}
                    removable={false}
                    itemValueAttrName="zobrazJmeno"
                />
                <CustomCheckboxField label={t('labels.inactive')} name="neaktivni" disabled={submitting}/>
            </FormBody>
            <FormActions onClose={onClose} storeButton={t('save')} cancelButton={t('buttons.cancel')} disabled={submitting}/>
        </Form> : <Loader/>
    }
}

function mapStateToProps(state) {
    return {
        uzivateleSpolecnostList: utils.storeFromArea(state, subjektActions.SPOLECNOST_ZAMESTNANCI_LIST_AREA),
    }
}

export default withTranslation()(connect(mapStateToProps)(reduxForm({
    form: KartaForm.formName,
})(KartaForm)));
